import React from 'react';
import styled from 'styled-components';
import { ErrorOutline } from '@mui/icons-material';
import { Main, Text } from 'styles/themeColors';
import { TEXT_LABELS } from 'constants/productDetails';

const Container = styled.div`
  width: 70%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 0;
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  color: ${Main.error};
`;

const MessageText = styled.span`
  font-size: 1rem;
  color: ${Main.error};
  font-weight: 500;
`;

const DetailText = styled.span`
  font-size: 1rem;
  color: ${Text.secondary};
`;

interface Props {
  resetTime: string;
}

const TokenLimitExhausted: React.FC<Props> = ({
  resetTime,
}) => {
  return (
    <Container>
      <IconWrapper>
        <ErrorOutline style={{ fontSize: '2rem' }} />
      </IconWrapper>
      <span>
        <MessageText>{TEXT_LABELS.TOKEN_LIMIT_TITLE} </MessageText>
        {resetTime && <DetailText>&nbsp;{TEXT_LABELS.RESET_TIME_TITLE} {resetTime}.</DetailText>}
      </span>
    </Container>
  );
};

export default TokenLimitExhausted;
